<div class="row main">
  <div class="column twelve">
    <h4
      class="heading-sub-section"
      dsContent
      [contentPath]="'profile.mandateTitle'"
      data-cy="updateContactMandateTitle"
    ></h4>
    <p
      class="pad-top-10 margin-bottom-20"
      dsContent
      [contentPath]="'profile.mandateMainText'"
      data-cy="updateContactMandateMainText"
    ></p>
    <p
      class="pad-top-10 margin-bottom-20"
      dsContent
      [contentPath]="'profile.mandateSubText'"
      data-cy="updateContactMandateSubText"
    ></p>
    <p class="pad-top-10 margin-bottom-10">
      <span dsContent [contentPath]="'profile.mandateEmail'"></span
      ><strong>{{ email$ | async }}</strong>
    </p>
    <p class="pad-top-10 margin-bottom-20">
      <span dsContent [contentPath]="'profile.mandatePhone'"></span>
      @if (phone$ | async) {
        <span
          ><strong>{{ phone$ | async | prettyPhoneNumber }}</strong></span
        >
      }
    </p>
    <p class="pad-top-10 margin-bottom-20" dsContent [contentPath]="'profile.mandateConfirm'"></p>
    <button
      ds-button
      type="button"
      class="margin-top-10 -outline-white margin-right-10"
      dsRouterLink="/profile"
      [queryParams]="{ openAccordion: 'contact' }"
      [attr.aria-label]="mandateMakeChangesBtnContent"
      data-cy="updateContactMandateMakeChangesButton"
    >
      {{ mandateMakeChangesBtnContent }}
    </button>
    <button
      ds-button
      type="button"
      class="margin-top-10 margin-right-10"
      dsRouterLink="/overview"
      [attr.aria-label]="mandateLooksGoodBtnContent"
      data-cy="updateContactMandateLooksGoodButton"
    >
      {{ mandateLooksGoodBtnContent }}
    </button>
  </div>
</div>
